export const HERO_CONSTANTS = {
  TAG: "Tech Innovation",
  DATE: "October 23, 2023",
  TITLE: "Boost Your Productivity with AI Code Assistants",
  DESCRIPTION:
    "Explore how AI code assistants are revolutionizing software development by providing intelligent code suggestions, error detection, and automated documentation.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "AI code assistants are transforming the software development landscape by offering advanced features that enhance productivity and code quality. This guide delves into the benefits and applications of AI code assistants in modern development workflows.",
  "From real-time code suggestions to automated error detection, AI code assistants provide valuable support for developers at all skill levels. We'll explore how these tools can streamline your coding process and improve overall efficiency.",
  "Whether you're a seasoned developer or just starting out, AI code assistants offer powerful capabilities that can help you write better code faster. Let's examine the key features and advantages of these innovative tools.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding AI Code Assistants",
    content:
      "AI code assistants leverage machine learning algorithms to provide intelligent code suggestions, detect errors, and automate repetitive tasks. These tools analyze your code in real-time, offering context-aware recommendations to improve your workflow.",
  },
  {
    title: "2. Key Features and Benefits",
    content:
      "AI code assistants offer a range of features, including syntax highlighting, code completion, error detection, and automated documentation. These capabilities help developers write cleaner, more efficient code while reducing the likelihood of bugs.",
  },
  {
    title: "3. Integrating AI Code Assistants into Your Workflow",
    content:
      "Integrating AI code assistants into your development environment is straightforward. Most tools are compatible with popular IDEs and code editors, allowing you to seamlessly incorporate them into your existing workflow.",
  },
  {
    title: "4. Enhancing Collaboration with AI",
    content:
      "AI code assistants can also improve collaboration among development teams by providing consistent code suggestions and enforcing coding standards. This ensures that all team members adhere to best practices, resulting in more maintainable codebases.",
  },
  {
    title: "5. Future Trends in AI-Powered Development",
    content:
      "The field of AI-powered development is rapidly evolving, with new advancements and features being introduced regularly. Staying informed about the latest trends helps developers leverage the full potential of AI code assistants and stay competitive in the industry.",
  },
  {
    title: "6. Choosing the Right AI Code Assistant",
    content:
      "When selecting an AI code assistant, consider factors such as compatibility, features, and pricing. Look for tools that offer robust support for your preferred programming languages and development environments.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/1181676/pexels-photo-1181676.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top AI Tools for Software Development",
    description:
      "Discover the best AI tools available for software development, from code assistants to testing frameworks. Learn how these technologies can enhance your development process.",
  },
  {
    image:
      "https://images.pexels.com/photos/1181677/pexels-photo-1181677.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How AI is Transforming the Tech Industry",
    description:
      "Explore the various ways AI is revolutionizing the tech industry, from software development to data analysis. Understand the impact of AI on the future of technology.",
  },
  {
    image:
      "https://images.pexels.com/photos/1181678/pexels-photo-1181678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Improving Code Quality with AI",
    description:
      "Learn how AI code assistants can help you write cleaner, more efficient code. Follow our guide to enhance your coding skills with the help of AI.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Join the AI Development Revolution",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/1181679/pexels-photo-1181679.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Subscribe Now",
  COPYRIGHT: " 2024 AI Development. All rights reserved",
};
